export default __webpack_public_path__ + "static/media/foreground_tree.be84f661.svg";